import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { LayoutPreferencesProvider } from './contexts/LayoutPreferencesContext';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* LayoutPreferences must wrap ThemeProvider: the Text size axis lives
          in the former but is applied by the latter's typography scale. */}
      <LayoutPreferencesProvider>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </LayoutPreferencesProvider>
    </BrowserRouter>
  </React.StrictMode>
);
